/**
 * @Author: liuchang
 * @Date: 2019-08-14 20:27:01
 * @Description: 公共方法
 */
export default {
    install (Vue, options) {
        /**
         * @author: liuchang
         * @description: 查询Bean处理
         * @param {type}
         */
        Vue.prototype.processPieData = function (prop, op, value, fieldType) {
            let node = {
                'prop': prop,
                'op': op,
                'value': value,
                'fieldType': fieldType,
                'singleValue': false,
                'betweenValue': false,
                'listValue': false
            };
            if (node.value.length == 1) {
                node.singleValue = true;
            } else if (node.value.length == 2) {
                node.betweenValue = true;
            } else if (node.value.length > 3) {
                node.listValue = true;
            } else {
                // 无数据
                return [];
            }
            return node;
        };

        /**
         *  自定义表格搜索字段方法
         *  @param page 当前页码
         *  @param pageSize pageSize一页显示的数量
         *  @param searchStr 搜索字段
         *  @param sortType 排序方式
         *  @param sortField 排序字段
         */
        Vue.prototype.buildQueryBean = function (page, pageSize, searchNode, sortType, sortField) {
            let search = {
                'current': 1,
                'pageSize': 10,
                'search': false,
                'sort': false,
                'sortField': '',
                'sortType': 'desc',
                'filters': []
            };
            if (page) {
                search.current = page;
            }
            if (pageSize) {
                search.pageSize = pageSize;
            }
            if (searchNode) {
                search.search = true;
                search.filters = searchNode;
            }
            if (sortType) {
                search.sort = true;
                search.sortField = sortField;
                search.sortType = sortType;
            }
            return search;
        };

        /**
         * 创建搜索bean
         * @param {String} prop 参数名称
         * @param {操作符} op
         * @param {值} value
         * @param {字段类型} fieldType
         */
        Vue.prototype.tableSearchNode = function (prop, op, value, fieldType, isArray) {
            let node = {
                'prop': prop,
                'op': op,
                'value': value,
                'fieldType': fieldType,
                'singleValue': false,
                'betweenValue': false,
                'listValue': false
            };
            if (isArray) {
                node.listValue = true;
                return node;
            }
            if (!node.value) {
                node.singleValue = true;
            } else if (node.value.length == 1) {
                node.singleValue = true;
            } else if (node.value.length == 2) {
                node.betweenValue = true;
            } else if (node.value.length >= 3) {
                node.listValue = true;
            } else {
                // 无数据
                return [];
            }
            return node;
        };

        /**
         * @author: liuchang
         * @description: 整合成一个数组
         * @param {type}
         */
        Vue.prototype.buildNodeList = function (...node) {
            return node;
        };

        /**
         * @author: liuchang
         * @description: 深拷贝方法
         * @param {type}
         */
        Vue.prototype.deepClone = function (initalObj, finalObj) {
            var obj = finalObj || {};
            for (var i in initalObj) {
                var prop = initalObj[i];
                // 避免相互引用对象导致死循环，如initalObj.a = initalObj的情况
                if (prop === obj) {
                    continue;
                }
                if (typeof prop === 'object') {
                    obj[i] = (prop.constructor === Array) ? [] : {};
                    arguments.call(prop, obj[i]);
                } else {
                    obj[i] = prop;
                }
            }
            return obj;
        };
        /**
         * @author: liuc
         * @description: 节流
         * @param {} {*} 使用时调用示例 this.throttle(this.search, 5000)();
         */
        Vue.prototype.throttle = function (fn, delay) {
            let that = this;
            let timer = this.timer;
            let begin = new Date().getTime();
            return function () {
                let current = new Date().getTime();
                clearTimeout(timer);
                if (current - begin - delay >= 0) {
                    fn();
                    begin = current;
                } else {
                    that.timer = setTimeout(function () {
                        fn();
                    }, delay);
                }
            };
        };
        /**
         * @author: liuc
         * @description: 防抖
         * @param {} {*} func 要执行的方法
         * @param {} {*} delay 固定时间，毫秒
         * @param {} {*} immediate设置为false
         */
        Vue.prototype.debounce = function (func, delay, immediate) {
            let timeout;
            return function () {
                let context = this;
                let args = arguments;
                if (timeout) clearTimeout(timeout); // timeout 不为null
                if (immediate) {
                    let callNow = !timeout; // 第一次会立即执行，以后只有事件执行后才会再次触发
                    timeout = setTimeout(function () {
                        timeout = null;
                    }, delay);
                    if (callNow) {
                        func.apply(context, args);
                    }
                } else {
                    timeout = setTimeout(function () {
                        func.apply(context, args);
                    }, delay);
                }
            };
        };
    }
};



// WEBPACK FOOTER //
// ./src/public/public.js